import { ActivityType } from '@kaa/api/customers';
import { Icon } from '@kaa/ui-flanders/components';

export const ACTIVITY_TYPE_ICON = {
  [ActivityType.IRONING]: Icon.IRONING,
  [ActivityType.HOUSEKEEPING]: Icon.VACCUM_CLEANER,
  [ActivityType.GROCERY_SHOPPING]: Icon.SHOPPING,
  [ActivityType.DISABLED_PERSON_TRANSPORTATION]: Icon.TRANSPORT,
};
